<template>
  <div class="get-start-section__right">
    <div class="get-start-section__tabcontent">
      <div class="form-hubspot form-sidebar">
        <div id="submission-form" class="form-div">
          <form
            method="POST"
            accept-charset="UTF-8"
            enctype="multipart/form-data"
            novalidate=""
            action=""
            class="form"
          >
            <FormField
              id="name"
              placeholder="Enter your name"
              require="true"
              autocomplete="full-name"
              label="Full Name"
              :value="customerName"
              @change="customerName = $event.target.value"
            ></FormField>
            <FormField
              id="email"
              placeholder="Enter your Email"
              require="true"
              autocomplete="email"
              label="Email"
              :value="email"
              @change="email = $event.target.value"
            ></FormField>
            <div class="legal-consent-container">
              <div class="hs-richtext">
                <p>
                  By submitting this form, you accept the terms in our
                  <a href="https://torq.io/privacy/" target="_blank"
                    >privacy policy</a
                  >.
                </p>
              </div>
            </div>
            <div class="error_rollup">
              <ul
                v-if="this.errorMsg !== ''"
                class="no-list error-msgs inputs-list"
              >
                <li>
                  <label class="hs-main-font-element">
                    {{ this.errorMsg }}
                  </label>
                </li>
              </ul>
            </div>
            <div v-if="this.successMessage !== ''" class="success_rollup">
              <ul></ul>
              <label>
                {{ this.successMessage }}
              </label>
            </div>
            <SubmitButton
              v-if="submitVisible"
              :enabled="submitEnabled"
              @onSubmit="onSubmit"
              :is-loading="isLoading"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormField from "@/components/FormField";
import SubmitButton from "@/components/SubmitButton";

export default {
  name: "SubmissionForm",
  components: { SubmitButton, FormField },
  data() {
    return {
      submitEnabled: true,
      submitVisible: true,
      customerName: "",
      email: "",
      errorMsg: "",
      successMessage: "",
      isLoading: false,
    };
  },
  props: {
    submissionUrl: String,
  },
  methods: {
    getUrlParameter(name) {
      name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
      const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
      const results = regex.exec(location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    },
    showAlert(msg) {
      this.errorMsg = msg;
    },
    hideAlert() {
      this.errorMsg = "";
    },
    showSuccess(msg) {
      this.successMessage = msg;
    },
    async onSubmit() {
      this.isLoading = true;
      this.hideAlert();
      this.submitEnabled = false;
      let token = this.getUrlParameter("x-amzn-marketplace-token");
      let source = "amzn";
      if (!token) {
        token = this.getUrlParameter("x-gcp-marketplace-token");
        source = "gcp";
      }
      if (!token) {
        this.showAlert(
          "Registration Token Missing. Please go to AWS Marketplace and follow the instructions to set up your account!"
        );
        this.isLoading = false;
        return;
      }
      if (!this.customerName || !this.email) {
        this.showAlert("PLEASE COMPLETE ALL REQUIRED FIELDS.");
        this.submitEnabled = true;
        this.isLoading = false;
        return;
      }
      const data = {
        regToken: token,
        source: source,
        name: this.customerName,
        email: this.email,
      };
      const xhr = new XMLHttpRequest();

      xhr.open("POST", this.submissionUrl, true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(JSON.stringify(data));

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          this.isLoading = false;
          if (xhr.status > 204) {
            this.showAlert(
              "Registration Failed. Please reach out to support@torq.io"
            );
            this.submitEnabled = true;
          } else {
            this.submitVisible = false;
            this.showSuccess("Thank you for signing-up to Torq!");
          }
          console.log(JSON.stringify(xhr.responseText));
        }
      };
    },
  },
};
</script>

<style scoped>
.get-start-section__right {
  padding: 0 0 110px 75px;
  position: relative;
  margin-top: 25%;
  width: 100vw;
}

.get-start-section__tabcontent {
}

.get-start-section__copy {
  margin-top: 30px;
  max-width: 460px;
}

.get-start-section__form__header {
  color: var(--black);
  margin-bottom: 23px;
}

.get-start-section__form__subheader {
  color: var(--black);
  margin-bottom: 20px;
}

.get-start-section__tabs {
  display: flex;
  flex-direction: row;
  max-width: 380px;
  width: 100%;
  background-color: var(--white-smoke);
  border-radius: 6px;
  margin-bottom: 18px;
}

.get-start-section__tab {
  cursor: pointer;
  height: 53px;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background-color: var(--white);
}

.get-start-section__cta-block {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 33px 0;
  max-width: 380px;
  width: 100%;
}

.get-start-section__cta {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: var(--seafoam);
  text-decoration: none;
  background-color: var(--dark-grey-blue);
  cursor: pointer;
  outline: none;
  border: none;
  padding: 0;
}

svg {
  transform: rotate(90deg);
}

.get-start-section__form {
  width: 100%;
  margin: 0 auto 0 0;
}

.get-start-section__cta__icon {
  position: relative;
  width: 19px;
  height: 19px;
  margin-left: 9px;
  transform: rotate(90deg);
}

.form p {
  font-size: 13px;
  font-family: Work Sans, serif;
  font-weight: var(--normal);
  line-height: 1.2;
  padding-bottom: 0;
  margin-bottom: 14px;
}

.error_rollup li {
  display: block;
  background: url("~@/assets/alert.svg") no-repeat 0 0;
  background-size: 15px 15px;
  margin: 5px 0 0;
  padding: 2px 0 2px 20px;
  font-weight: 600;
  line-height: 1;
  font-size: 12px;
}

.error_rollup ul {
  padding-inline-start: 0;
}

.success_rollup {
  line-height: 1;
  font-size: 15px;
  margin: 0 0 20px 0;
  text-align: left;
}

.legal-consent-container {
  text-align: left;
}
</style>
